import AppShell from "@/components/layout/AppShell";
import PageHeader from "@/components/ui/PageHeader";
import StatCard from "@/components/ui/StatCard";
import Card from "@/components/ui/Card";
import { store } from "@/lib/store";
import { peso } from "@/lib/utils";

export default function DashboardPage() {
  const products = store.getProducts();
  const orders = store.getOrders();
  const customers = store.getCustomers();

  const totalSales = orders.reduce((sum, order) => sum + order.totalAmount, 0);
  const totalStock = products.flatMap((p) => p.variants).reduce((sum, v) => sum + v.stock, 0);
  const lowStock = products.flatMap((p) => p.variants).filter((v) => v.stock - v.reserved <= 5).length;

  return (
    <AppShell>
      <PageHeader title="Dashboard" description="Overview of your inventory and sales performance." />

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        <StatCard label="Total Sales" value={peso(totalSales)} />
        <StatCard label="Products" value={String(products.length)} />
        <StatCard label="Customers" value={String(customers.length)} />
        <StatCard label="Total Stock Units" value={String(totalStock)} />
      </div>

      <div className="mt-6 grid gap-4 lg:grid-cols-2">
        <Card>
          <h3 className="text-lg font-semibold text-gray-900">Low Stock Alerts</h3>
          <p className="mt-2 text-3xl font-bold text-brand-600">{lowStock}</p>
          <p className="mt-1 text-sm text-gray-500">Variants with 5 or fewer available units.</p>
        </Card>

        <Card>
          <h3 className="text-lg font-semibold text-gray-900">Recent Orders</h3>
          <div className="mt-4 space-y-3">
            {orders.slice(0, 4).map((order) => (
              <div key={order.id} className="flex items-center justify-between rounded-xl bg-rose-50 px-4 py-3">
                <div>
                  <p className="font-medium text-gray-900">{order.orderNumber}</p>
                  <p className="text-sm text-gray-500">{order.customerName} · {order.channel}</p>
                </div>
                <div className="font-semibold text-gray-900">{peso(order.totalAmount)}</div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </AppShell>
  );
}